export default __webpack_public_path__ + "static/media/grafema_martini-contest_04.14157e92.jpg";